export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11620.fac37016.jpg";